// Module
var code = `<button type="button" class="close" aria-label="{{ 'Generic.Close' | translate }}" ng-click="modalCloseButtonController.onClick()"></button> `;
// Exports
module.exports = code;